"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.textureLoad = void 0;
const rgbe_load_1 = require("./rgbe-load");
const THREE = require("three");
const textureLoad = (path, renderer) => __awaiter(void 0, void 0, void 0, function* () {
    const hdr = yield (0, rgbe_load_1.rgbeLoad)(path);
    const generator = new THREE.PMREMGenerator(renderer);
    generator.compileEquirectangularShader();
    const texture = generator.fromEquirectangular(hdr).texture;
    hdr.dispose();
    generator.dispose();
    return texture;
});
exports.textureLoad = textureLoad;
